import { render, staticRenderFns } from "./generalInspectionListDetails.vue?vue&type=template&id=436afdf4&scoped=true&"
import script from "./generalInspectionListDetails.vue?vue&type=script&lang=js&"
export * from "./generalInspectionListDetails.vue?vue&type=script&lang=js&"
import style0 from "./generalInspectionListDetails.vue?vue&type=style&index=0&id=436afdf4&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436afdf4",
  null
  
)

export default component.exports